import { ComponentType, FC, SVGProps } from 'react';
import {
  Content,
  DropdownItem,
  DropdownMenu,
  Portal,
  Trigger,
} from 'components/DsDropdown/DropdownMenu';
import styles from './LinkDropdown.module.scss';
import { Link } from 'components/Link';
import { Pointer } from '@yleisradio/areena-types';
import classNames from 'classnames';

export type LinkDropdownData = {
  Icon: FC<SVGProps<SVGAElement>>;
  label: string;
  pointer?: Pointer;
  handleOnClick?: () => void;
};

type Props = {
  TriggerIcon: ComponentType;
  data: LinkDropdownData[];
  size: 'sm' | 'md';
  triggerAriaLabel: string;
};

const LinkDropdown: FC<Props> = ({
  TriggerIcon,
  data,
  size,
  triggerAriaLabel,
}) => {
  return (
    <DropdownMenu modal={false}>
      <Trigger className={styles.trigger} aria-label={triggerAriaLabel}>
        <TriggerIcon />
      </Trigger>
      <Portal>
        <Content className={styles.list}>
          {data.map((link, index) => {
            const { Icon } = link;

            const itemClasses = classNames(
              styles.item,
              styles[`item-size-${size}`]
            );
            return (
              <DropdownItem key={index} className={styles.itemContainer}>
                {link.pointer && (
                  <Link pointer={link.pointer} className={itemClasses}>
                    <Icon className={styles.icon} aria-hidden />
                    <div className={styles.label}>{link.label}</div>
                  </Link>
                )}
                {link.handleOnClick && (
                  <button className={itemClasses} onClick={link.handleOnClick}>
                    <Icon className={styles.icon} aria-hidden />
                    <div className={styles.label}>{link.label}</div>
                  </button>
                )}
              </DropdownItem>
            );
          })}
        </Content>
      </Portal>
    </DropdownMenu>
  );
};

export { LinkDropdown };
